/* Arbuckles advertorial / listicle (arb-adv-* sections)
   Reading progress, pinned masthead, contents highlighting, sticky offer bar,
   smooth in-page jumps and CTA / read-depth events for analytics.
   Reveal animations come from arb-ss.js ([data-arb-reveal]). */
(function () {
  'use strict';
  if (window.__arbAdv) return;
  window.__arbAdv = true;

  var root = document.documentElement;
  var mqDesk = window.matchMedia('(min-width: 990px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }

  var el = {};
  var maxSeen = 0;
  var lastActive = -1;

  function collect() {
    el.mast = $('[data-adv-mast]');
    el.mastBar = el.mast ? $('[data-adv-mast-bar]', el.mast) : null;
    el.hero = $('[data-adv-hero]');
    el.article = $('[data-adv-article]');
    el.reasons = $$('[data-adv-reason]');
    el.toc = $$('[data-adv-toc]');
    el.count = $$('[data-adv-count]');
    el.bar = $('[data-adv-bar]');
    el.offers = $$('[data-adv-offer], [data-adv-final]');
    el.foot = $('[data-adv-foot]');
    lastActive = -1;
  }

  /* ---------------- analytics ---------------- */
  function track(name, data) {
    data = data || {};
    data.page = window.location.pathname;
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      Object.keys(data).forEach(function (k) { payload['adv_' + k] = data[k]; });
      window.dataLayer.push(payload);
    } catch (e) { /* no-op */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* no-op */ }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-adv-cta]') : null;
    if (a) track('adv_cta_click', { location: a.getAttribute('data-adv-cta'), href: a.getAttribute('href') || '' });

    // smooth in-page jumps (contents, skip link); scroll-margin-top handles the pinned masthead
    var link = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!link || !link.closest('.arb')) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: mqReduce.matches ? 'auto' : 'smooth', block: 'start' });
    if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* ---------------- scroll state ---------------- */
  function inView(node, vh) {
    if (!node) return false;
    var r = node.getBoundingClientRect();
    return r.top < vh && r.bottom > 0;
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || root.clientHeight;

    // reading progress across the article
    if (el.article) {
      var ar = el.article.getBoundingClientRect();
      var p = ar.height > 0 ? clamp((vh * 0.35 - ar.top) / ar.height, 0, 1) : 0;
      root.style.setProperty('--adv-p', p.toFixed(4));
    }

    // pinned masthead (desktop only; phones keep the sticky offer bar instead)
    if (el.mast && el.mastBar) {
      var pin = mqDesk.matches && el.mast.getBoundingClientRect().top < 0;
      if (pin !== el.mastBar.classList.contains('is-pinned')) el.mastBar.classList.toggle('is-pinned', pin);
    }

    // which reason is being read
    var active = 0;
    var line = vh * 0.38;
    for (var i = 0; i < el.reasons.length; i++) {
      if (el.reasons[i].getBoundingClientRect().top <= line) active = i + 1;
    }
    if (active !== lastActive) {
      lastActive = active;
      el.toc.forEach(function (a) {
        var n = parseInt(a.getAttribute('data-adv-toc'), 10);
        if (n === active) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
        a.classList.toggle('is-done', n < active);
      });
      el.count.forEach(function (c) { c.textContent = active; });
      if (active > maxSeen) {
        for (var k = maxSeen + 1; k <= active; k++) track('adv_reason_view', { reason: k, of: el.reasons.length });
        maxSeen = active;
      }
    }

    // sticky offer bar (phones/tablets)
    if (el.bar) {
      var show = false;
      if (!mqDesk.matches) {
        var pastHero = el.hero ? el.hero.getBoundingClientRect().bottom < 0 : window.pageYOffset > 600;
        var offerOnScreen = el.offers.some(function (o) { return inView(o, vh); });
        var footOnScreen = el.foot ? el.foot.getBoundingClientRect().top < vh : false;
        show = pastHero && !offerOnScreen && !footOnScreen;
      }
      if (show !== el.bar.classList.contains('is-on')) {
        el.bar.classList.toggle('is-on', show);
        el.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var btn = $('a', el.bar);
        if (btn) btn.tabIndex = show ? 0 : -1;
        root.classList.toggle('arb-adv-bar-on', show);
      }
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function boot() {
    collect();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onScroll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // theme editor
  document.addEventListener('shopify:section:load', function () { collect(); update(); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { collect(); update(); }, 0); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target && e.target.scrollIntoView) e.target.scrollIntoView({ block: 'center' });
  });
})();
